import { Component, OnInit, ViewChild } from '@angular/core';
import * as jwt_decode from 'jwt-decode';
import { ModalErroComponent } from 'src/app/components/modal-erro/modal-erro.component';
import { ModalSidebarService } from 'src/app/components/modal-sidebar/modal-sidebar.service';
import { UserAuthIamService } from 'src/app/features/proof-of-life/services/user-auth-iam/user-auth-iam.service';
import { TemplateMaisInformacoes } from 'src/app/utils/template-mais-informacoes';
import { environment } from 'src/environments/environment';
import { GerenciarPreferenciasService } from './gerenciar-preferencias.service';
@Component({
  selector: 'app-gerenciar-preferencias',
  templateUrl: './gerenciar-preferencias.component.html',
  styleUrls: ['./gerenciar-preferencias.component.scss'],
})
export class GerenciarPreferenciasComponent implements OnInit {
  info: any;
  //Mobile inputs/switches
  optionOneActive: boolean = false;
  optionTwoActive: boolean = false;
  userOptLastUpdate: any;
  userOptStatus: any;
  userOptEvent: any;
  userOptMeio: number;
  userOptOrigem: number;
  userOptOpenProtocol: boolean;
  userOptProtocolNumber: any;
  changedStatus: string;
  decoded: any;
  @ViewChild('modalErro') modalErro: ModalErroComponent;
  ocultarModalErro: boolean = false;

  userIsLoggedIn: boolean = false;

  actionButtons: Array<Object> = [
    {
      buttonTitle: 'Ligações de Telemarketing',
      buttonDescription:
        'Visando a auxiliar os consumidores que desejam não ser incomodados com ligações de telemarketing, alguns PROCONs estaduais (Programa de Proteção e Defesa do Consumidor) permitem que os consumidores cadastrem suas linhas telefônicas para impedir o contato por empresas que queiram oferecer produtos e serviços. Essa iniciativa é válida, por exemplo, em São Paulo, Paraná, Santa Catarina e Rio Grande do Sul.<br><br> Para bloquear ligações indesejadas em até 5 linhas telefônicas por CPF, <a href="www.procon.sp.gov.br">acesse o site do Procon</a> e cadastre-se gratuitamente.',
      buttonDisclaimer:
        'É importante que você saiba que estas medidas não retiram os seus dados pessoais dos bancos de dados da Serasa Experian.',
    },
    {
      buttonTitle: 'E-mail marketing de empresas diversas',
      buttonDescription:
        'Se você recebe muitos e-mails de remetentes ou assuntos indesejados e não quer mais receber esse tipo de conteúdo, os gerenciadores de e-mail (como o Gmail e o Outlook, por exemplo) oferecem ferramentas que podem te ajudar a resolver esse problema.<br><br>Você pode acessar o link para se descadastrar da lista de e-mails da empresa que enviou a publicidade, disponível quase sempre no fim das mensagens que você recebe.<br><br>Caso identifique e-mails não solicitados/indesejados que geralmente são enviados para um grande número de pessoas, sinalize a mensagem ou o remetente como ‘SPAM’ e as próximas mensagens disparadas para você pelo mesmo remetente serão desviadas automaticamente para o lixo eletrônico.',
      buttonDisclaimer:
        'É importante que você saiba que estas medidas não retiram os seus dados pessoais dos bancos de dados da Serasa Experian.',
    },
    {
      buttonTitle: 'Configurações de privacidade',
      buttonDescription:
        'Em seu smartphone, você pode permitir ou revogar o acesso de aplicativos a determinadas informações, como a sua lista de contatos ou a câmera do aparelho. Nas configurações do sistema operacional, você altera quando quiser a opção que foi feita no momento da instalação de cada aplicativo.<br><br>Todos os sites e redes sociais possuem suas políticas de privacidade e termos de uso. Consulte mais informações em cada site específico para verificar como seus dados são utilizados e para, se aplicável, configurar suas preferências de privacidade.',
      buttonDisclaimer:
        'É importante que você saiba que estas medidas não retiram os seus dados pessoais dos bancos de dados da Serasa Experian.',
    },
  ];

  constructor(
    public modalSidebar: ModalSidebarService,
    private iamService: UserAuthIamService,
    private UserOptService: GerenciarPreferenciasService
  ) {
    if (sessionStorage.getItem('accessTokenJWT')) {
      this.decoded = jwt_decode(sessionStorage.getItem('accessTokenJWT'));
    }
  }

  ngOnInit(): void {
    this.optionOneActive = false;
    this.optionTwoActive = false;

    this.UserOptService.getUserStatus().subscribe(
      (data) => {
        if (data['dataAtualizacao'] == null) {
          this.userOptLastUpdate = data['dataCriacao'];
        } else {
          this.userOptLastUpdate = data['dataAtualizacao'];
        }

        this.userOptStatus = data['status'];
        this.userOptEvent = data['evento'];
        this.userOptMeio = data['meio'];
        this.userOptOrigem = data['origem'];
        this.userOptOpenProtocol = data['protocoloEmAberto'];
        this.userOptProtocolNumber = data['protocolo'];
      },
      (error) => {
        console.log('error getUserData', error);
      }
    );

    this.iamService.accountData().subscribe(
      (data) => {
        this.userIsLoggedIn = true;
      },
      () => {
        this.userIsLoggedIn = false;
      }
    );
  }

  showModal(title, descriptionFull, disclaimerInfo) {
    let modalInfo = {
      title: title,
      description: descriptionFull,
      disclaimerInfo: disclaimerInfo,
    };

    this.modalSidebar.setModalData(modalInfo, true);
  }

  redirectLogin() {
    var currentPath = window.location.toString();
    window.location.href =
      environment.urlPortal + '/entrar?redirectUrl=' + currentPath;
  }

  selectOption(optionNumber) {
    if (optionNumber == 1) {
      this.optionTwoActive = false;
      this.changedStatus = 'optout';
    } else if (optionNumber == 2) {
      this.optionOneActive = false;
      this.changedStatus = 'optin';
    } else {
      this.optionOneActive = false;
      this.optionTwoActive = false;
    }
  }

  changeUserStatus() {
    let meio: number;

    if (this.decoded.authorities.includes('ROLE_PERSON_VALIDATED')) {
      meio = 36;
    } else if (this.decoded.authorities.includes('ROLE_AUTH-STRONG')) {
      meio = 33;
    } else {
      alert('A solicitação não pode ser enviada no momento.');
    }

    const bodyReq = {
      evento: this.changedStatus,
      meio: meio,
      origem: 22,
    };
    this.UserOptService.postNewStatus(bodyReq).subscribe(
      (res) => {
        this.windowReload();
      },
      (err) => {
        this.ocultarModalErro = true;
        this.modalErro.open();
      }
    );
  }

  showModalMaisInformacoes() {
    this.info = {
      title: '',
      description: TemplateMaisInformacoes.obterTemplateMaisInformacoes(),
    };

    this.modalSidebar.setModalData(this.info, true);
  }

  windowReload() {
    setTimeout(() => {
      location.reload();
    }, 1000);
  }
}
